import { gql } from '@apollo/client';

export const GET_TEMPLATE_DETAIL = gql`
  query getTemplateDetail($id: ID!) {
    template(id: $id) {
      data {
        id
        attributes {
          name
          template
        }
      }
    }
  }
`;

export interface TemplateDetailVars {
  id: string;
}

export interface TemplateDetailData {
  template: {
    data: {
      id: string;
      name: string;
      template: string;
    } | null;
  } | null;
}
